export default __webpack_public_path__ + "static/media/gokce9.06372298.jpg";